import { useEffect, useState } from 'react';
import Search from '../../../../../Assets/Modals/SearchIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedProduct } from '../../../../../Features/inventoryManagementSlice';
import ArrowRight from '../../../../../Assets/ArrawRight.svg';

function SearchProduct() {
    const dispatch = useDispatch();

    const [value, setValue] = useState('');

    const { products } = useSelector((state) => state.inventoryManagement.products);

    const handleChange = (e) => {
        setValue(e.target.value);
    }

    const [productList, setProductList] = useState([]);

    const handleSelectProduct = (product) => {
        dispatch(setSelectedProduct(product));
    }

    useEffect(() => {
        if(value) {
            const filteredProducts = products.filter(item => item.product.status !== 'Draft').filter(product => product.product.productName.toLowerCase().includes(value.toLowerCase()));
            setProductList(filteredProducts);
        }
        else {
            setProductList(products);
        }
    }, [value]);

    return (
        <div className='flex flex-col gap-3 h-[calc(100%-44px)]'>
            <div className="relative flex items-center gap-1 border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px]">
                <div className="w-6 h-6 flex items-center justify-center">
                    <img src={Search} alt="" />
                </div>

                <input 
                    className='w-[calc(100%-24px)] bg-transparent outline-none placeholder:font-normal font-medium text-base placeholder:text-[#666666] text-[#121212]' 
                    id='product-search' 
                    name='product-search' 
                    placeholder='Search products'
                    type="text" 
                    value={value} 
                    onChange={handleChange} 
                />
            </div>

            <p className='font-semibold text-[18px] leading-6 text-[#757575]'>Low stock Products</p>

            <div className="h-[calc(100%-80px)] overflow-y-scroll w-full no-scrollbar">
                {
                    (productList?.length > 0 && productList?.length !== products?.length) ?
                    (
                        productList?.map(product => {
                            const item ={}

                            const leastVariant = product?.varients?.length
                                ? product.varients.reduce((min, v) =>
                                    v.quantity < min.quantity ? v : min
                                    )
                                : null;

                            if(leastVariant) {
                                item.id = leastVariant.ProductId;
                                item.images = leastVariant.VarientImgUrl;
                                item.name = leastVariant.VarientName;
                                item.size = leastVariant.VarientSize;
                                item.color = leastVariant.VarientColor;
                                item.stock = leastVariant.VarientQuantity === "" ? 0 : leastVariant.VarientQuantity ?? 0;
                            }
                            else {
                                item.id = product?.product?.id;
                                item.images = product?.product?.productImgUrls;
                                item.name = product?.product?.productName;
                                item.size = product?.product?.productSpecs?.size;
                                item.color = product?.product?.productSpecs?.color;
                                item.stock = product?.product?.productStock === "" ? 0 : product?.product?.productStock ?? 0;
                            }

                            return (
                                <div key={item.id} className="flex items-center gap-2 py-[6px] border-t border-[#EAEAEA]">
                                    <div className="size-16 rounded-lg overflow-hidden">
                                        <img className='size-full object-cover' src={item.images[0] || ''} alt="" />
                                    </div>

                                    <div className="flex gap-2 w-[calc(100%-64px)]">
                                        <div className="flex flex-col gap-2 w-[calc(100%-24px)]">
                                            <h1 className='font-semibold text-[18px] leading-[26px] text-[#121212] w-full whitespace-nowrap overflow-hidden text-ellipsis'>{product.product.productName}</h1>

                                            <div className="flex items-center gap-1 font-medium text-[14px] leading-[22px] text-[#666666]">
                                                <span>{product?.varients?.length} variants</span>
                                            </div>
                                        </div>

                                        <div onClick={() => handleSelectProduct(product)} className="cursor-pointer size-6 flex items-center justify-center">
                                            <img src={ArrowRight} alt="" />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    ) : 
                    (
                        products.filter(item => item.product.status !== 'Draft').map(product => {
                            const item = {}

                            const leastVariant = product?.varients?.length
                                ? product.varients.reduce((min, v) =>
                                    v.VarientQuantity < min.VarientQuantity ? v : min
                                    )
                                : null;

                            if(leastVariant) {
                                item.id = leastVariant.ProductId;
                                item.images = leastVariant.VarientImgUrl;
                                item.name = leastVariant.VarientName;
                                item.size = leastVariant.VarientSize;
                                item.color = leastVariant.VarientColor;
                                item.stock = leastVariant.VarientQuantity === "" ? 0 : leastVariant.VarientQuantity ?? 0;
                                item.category = product?.product?.productCategory;
                            }
                            else {
                                item.id = product?.product?.id;
                                item.images = product?.product?.productImgUrls;
                                item.name = product?.product?.productName;
                                item.size = product?.product?.productSpecs?.size;
                                item.color = product?.product?.productSpecs?.color;
                                item.stock = product?.product?.productStock === "" ? 0 : product?.product?.productStock ?? 0;
                                item.category = product?.product?.productCategory;
                            }

                            return (
                                <div key={product.product.id} className="flex items-center gap-2 py-[6px] border-t border-[#EAEAEA]">
                                    <div className="size-16 rounded-lg overflow-hidden">
                                        {
                                            item.images ? 
                                            <img className='size-full object-cover' src={item?.images[0] || ''} alt="" /> : 
                                            <div className="size-16 rounded-lg bg-[#EAEAEA]"></div>
                                        }
                                    </div>

                                    <div onClick={() => handleSelectProduct(product)} className="cursor-pointer flex flex-col gap-2 w-[calc(100%-128px)]">
                                        <h1 className='font-semibold text-[18px] leading-[26px] text-[#121212] w-full whitespace-nowrap overflow-hidden text-ellipsis'>{product?.product?.productName}</h1>

                                        <div className="flex items-center gap-1 font-medium text-[14px] leading-[22px] text-[#666666]">
                                            <span>{item.category === 'Beauty & Personal Care' ? 'Volume' : 'Size'}: {item.size}</span>

                                            <span>Color: {item.color}</span>
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2 w-16 font-semibold text-base">
                                        <h1 className='text-[#666666]'>Stock</h1>

                                        <p className='text-[#121212]'>{item.stock}</p>
                                    </div>
                                </div>
                            )
                        })
                    )
                }
            </div>
        </div>
    );
}

export default SearchProduct;
